import DefaultRadioButton from '@images/svg-icons/defaultRadioButton.svg';
import RadioButton from '@images/svg-icons/radioButton.svg';
import BoxContact from '@images/svg-icons/boxContact.svg';
import BoxContactMobile from '@images/svg-icons/boxContactMobile.svg';

import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Checkbox } from '@mui/material';
import { getLabelFallback } from '@utils/utils'
import { RootState } from 'src/store/reducers';

const HowToReadPrescriptionCL = (): JSX.Element => {
    const isMobile = useSelector((state: RootState) => state.common.isMobile);

    const [isContactBoxPrescriptionSelected, setIsContactBoxPrescriptionSelected] = useState(false);
    const [isWrittenPrescriptionSelected, setIsWrittenPrescriptionSelected] = useState(true);

    const handleIsWrittenPrescriptionSelected = () => {
        if(isWrittenPrescriptionSelected !== true){
            setIsWrittenPrescriptionSelected(!isWrittenPrescriptionSelected);
            setIsContactBoxPrescriptionSelected(!isContactBoxPrescriptionSelected);
        }
    }

    const handleIsContactBoxPrescriptionSelected = () => {
        if(isContactBoxPrescriptionSelected !== true){
            setIsWrittenPrescriptionSelected(!isWrittenPrescriptionSelected);
            setIsContactBoxPrescriptionSelected(!isContactBoxPrescriptionSelected);
        }
    }

    return(                        
        <div
            className={`how-to-read-container ${isWrittenPrescriptionSelected ? "is-written-prescription" : isContactBoxPrescriptionSelected ? "on-box-selected" : ""}`}
        >
                <div className="how-to-read-cl-title"> {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_TITLE')}</div>
                <div className="how-to-read-cl-see-example">
                    <div className="how-to-read-cl-see-example-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_SEE_EXAMPLE')}</div>
                    <div className="how-to-read-cl-see-example-checkbox-container">
                        <div className="how-to-read-cl-see-example-checkbox">
                            <Checkbox
                                size="small"
                                sx={{
                                    color: 'black',
                                    '&.Mui-checked': {
                                        color: 'black',
                                    },
                                }}
                                icon={<DefaultRadioButton />}
                                checkedIcon={<RadioButton />}
                                checked={isWrittenPrescriptionSelected}  
                                onChange={handleIsWrittenPrescriptionSelected}
                            />
                            <span className="how-to-read-cl-see-example-checkbox-text"> {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_OPTION_ONE')}</span>
                        </div>
                        <div className="how-to-read-cl-see-example-checkbox">
                            <Checkbox
                                size="small"
                                sx={{
                                    color: 'black',
                                    '&.Mui-checked': {
                                        color: 'black',
                                    },
                                }}
                                icon={<DefaultRadioButton />}
                                checkedIcon={<RadioButton />}
                                checked={isContactBoxPrescriptionSelected}  
                                onChange={handleIsContactBoxPrescriptionSelected} 
                            />
                            <span className="how-to-read-cl-see-example-checkbox-text"> {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_OPTION_TWO')}</span>
                        </div>
                    </div>
                </div>
                {isWrittenPrescriptionSelected && (
                    <div className="how-to-read-cl-table">
                        <div className="how-to-read-cl-table-label"></div>
                        <div className="how-to-read-cl-table-label">
                            <div className="how-to-read-cl-table-label-legend number-one">
                                <span>1</span>
                            </div>
                            <span className="how-to-read-cl-table-label-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_RIGHT_EYE_NAME_NOT_EDIT')}</span>
                        </div>
                        <div className="how-to-read-cl-table-label">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_LEFT_EYE_NAME_NOT_EDIT')}</div>

                        <div className="how-to-read-cl-table-label">
                            <div className="how-to-read-cl-table-label-legend number-two">
                                <span>2</span>
                            </div>
                            <span className="how-to-read-cl-table-label-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_POWER')}</span>
                        </div>
                        <div className="how-to-read-cl-table-value">-0.75</div>
                        <div className="how-to-read-cl-table-value">-0.75</div>

                        <div className="how-to-read-cl-table-label">
                            <div className="how-to-read-cl-table-label-legend number-three">
                                <span>3</span>
                            </div>
                            <span className="how-to-read-cl-table-label-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_BC')}</span>
                        </div>
                        <div className="how-to-read-cl-table-value">8.5</div>
                        <div className="how-to-read-cl-table-value">8.5</div>

                        <div className="how-to-read-cl-table-label">
                            <div className="how-to-read-cl-table-label-legend number-four">
                                <span>4</span>
                            </div>
                            <span className="how-to-read-cl-table-label-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_DIA')}</span>
                        </div>
                        <div className="how-to-read-cl-table-value">14.5</div>
                        <div className="how-to-read-cl-table-value">14.5</div>

                        <div className="how-to-read-cl-table-label">
                            <div className="how-to-read-cl-table-label-legend number-five">
                                <span>5</span>
                            </div>
                            <span className="how-to-read-cl-table-label-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_CYL')}</span>
                        </div>
                        <div className="how-to-read-cl-table-value">-0.75</div>
                        <div className="how-to-read-cl-table-value">-0.75</div>

                        <div className="how-to-read-cl-table-label">
                            <div className="how-to-read-cl-table-label-legend number-six">
                                <span>6</span>
                            </div>
                            <span className="how-to-read-cl-table-label-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_AXIS')}</span>
                        </div>
                        <div className="how-to-read-cl-table-value">170</div>
                        <div className="how-to-read-cl-table-value">170</div>

                        <div className="how-to-read-cl-table-label">
                            <div className="how-to-read-cl-table-label-legend number-seven">
                                <span>7</span>
                            </div>
                            <span className="how-to-read-cl-table-label-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_ADD')}</span>
                        </div>
                        <div className="how-to-read-cl-table-value">-0.75</div>
                        <div className="how-to-read-cl-table-value">-0.75</div>
                    </div>
                )}
                {isContactBoxPrescriptionSelected && (
                    <div className="how-to-read-cl-grid">
                        <div className="how-to-read-cl-grid-box">
                            {!isMobile ? <BoxContact /> : <BoxContactMobile />}
                        </div>
                        <div className="how-to-read-cl-grid-content">
                            <div className="how-to-read-cl-grid-content-box">
                                <div className="how-to-read-cl-grid-content-box-content">
                                    <div className="how-to-read-cl-grid-content-box-content-number">
                                        <div className="how-to-read-cl-grid-content-box-content-number-legend number">
                                            <span>1</span>
                                        </div>
                                    </div>
                                    <div className="how-to-read-cl-grid-content-box-content-lr">
                                        <div className="how-to-read-cl-grid-content-box-content-lr-content right">
                                            <div className="how-to-read-cl-grid-content-box-content-lr-content-box">
                                                <div className="how-to-read-cl-grid-content-box-content-lr-content-box-draw"></div>
                                                <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_RIGHT_BOX_1')}</span>
                                            </div>
                                            <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_RIGHT_BOX_2')}</span>
                                        </div>
                                        <div className="how-to-read-cl-grid-content-box-content-lr-content left">
                                            <div className="how-to-read-cl-grid-content-box-content-lr-content-box">
                                                <div className="how-to-read-cl-grid-content-box-content-lr-content-box-draw"></div>
                                                <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEFT_BOX_1')}</span>
                                            </div>
                                            <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEFT_BOX_2')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="how-to-read-cl-grid-content-box">
                                <div className="how-to-read-cl-grid-content-box-content">
                                    <div className="how-to-read-cl-grid-content-box-content-number">
                                        <div className="how-to-read-cl-grid-content-box-content-number-legend number">
                                            <span>2</span>
                                        </div>
                                    </div>
                                    <div className="how-to-read-cl-grid-content-box-content-label">
                                        <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_POWER_BOX')}</span>
                                        <span>-0.75</span>
                                    </div>
                                </div>
                                <div className="how-to-read-cl-grid-content-box-content">
                                    <div className="how-to-read-cl-grid-content-box-content-number">
                                        <div className="how-to-read-cl-grid-content-box-content-number-legend number">
                                            <span>3</span>
                                        </div>
                                    </div>
                                    <div className="how-to-read-cl-grid-content-box-content-label">
                                        <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_BC')}</span>
                                        <span>8.5</span>
                                    </div>
                                </div>
                                <div className="how-to-read-cl-grid-content-box-content">
                                    <div className="how-to-read-cl-grid-content-box-content-number">
                                        <div className="how-to-read-cl-grid-content-box-content-number-legend number">
                                            <span>4</span>
                                        </div>
                                    </div>
                                    <div className="how-to-read-cl-grid-content-box-content-label">
                                        <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_DIA')}</span>
                                        <span>14.5</span>
                                    </div>
                                </div>
                                <div className="how-to-read-cl-grid-content-box-content">
                                    <div className="how-to-read-cl-grid-content-box-content-number">
                                        <div className="how-to-read-cl-grid-content-box-content-number-legend number">
                                            <span>5</span>
                                        </div>
                                    </div>
                                    <div className="how-to-read-cl-grid-content-box-content-label">
                                        <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_CYL')}</span>
                                        <span>-1.25</span>
                                    </div>
                                </div>
                                <div className="how-to-read-cl-grid-content-box-content">
                                    <div className="how-to-read-cl-grid-content-box-content-number">
                                        <div className="how-to-read-cl-grid-content-box-content-number-legend number">
                                            <span>6</span>
                                        </div>
                                    </div>
                                    <div className="how-to-read-cl-grid-content-box-content-label">
                                        <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_AXIS')}</span>
                                        <span>170</span>
                                    </div>
                                </div>
                                <div className="how-to-read-cl-grid-content-box-content">
                                    <div className="how-to-read-cl-grid-content-box-content-number">
                                        <div className="how-to-read-cl-grid-content-box-content-number-legend number">
                                            <span>7</span>
                                        </div>
                                    </div>
                                    <div className="how-to-read-cl-grid-content-box-content-label">
                                        <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_ADD')}</span>
                                        <span>+2.50</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="how-to-read-cl-legend">
                    <div className="how-to-read-cl-legend-list-one">
                        <div className="how-to-read-cl-legend-list-one-content">
                            <div className="how-to-read-cl-legend-list-one-content-number">
                                <span>1</span>
                            </div>
                            <div className="how-to-read-cl-legend-list-one-content-text">
                                <span className="how-to-read-cl-legend-list-one-content-text-title">
                                    {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TITLE')}
                                </span> 
                                <br />
                                <span className="how-to-read-cl-legend-list-one-content-text-text">
                                    {!isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_1')}
                                            <span style={{fontWeight: 700}}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_2')}</span>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_3')}
                                            <span style={{fontWeight: 700}}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_4')}</span><br/>
                                            <span style={{fontWeight: 700}}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_5')}</span>.
                                        </>
                                    )}
                                    {isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_1')}
                                            <span style={{fontWeight: 700}}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_2')}</span>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_3')}
                                            <span style={{fontWeight: 700}}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_4') + ' '}</span>
                                            <span style={{fontWeight: 700}}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_5')}</span>.
                                        </>
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className="how-to-read-cl-legend-list-one-content">
                            <div className="how-to-read-cl-legend-list-one-content-number">
                                <span>2</span>
                            </div>
                            <div className="how-to-read-cl-legend-list-one-content-text">
                                <span className="how-to-read-cl-legend-list-one-content-text-title">
                                    {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_POWER_TITLE')}
                                </span>
                                <br />
                                <span className="how-to-read-cl-legend-list-one-content-text-text">
                                    {!isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_POWER_TEXT_1')}<br />
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_POWER_TEXT_2')}
                                        </>
                                    )}
                                    {isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_POWER_TEXT_1') + ' '}
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_POWER_TEXT_2')}
                                        </>
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className="how-to-read-cl-legend-list-one-content">
                            <div className="how-to-read-cl-legend-list-one-content-number">
                                <span>3</span>
                            </div>
                            <div className="how-to-read-cl-legend-list-one-content-text">
                                <span className="how-to-read-cl-legend-list-one-content-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TITLE')}</span>
                                <br />
                                <span className="how-to-read-cl-legend-list-one-content-text-text">
                                    {!isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TEXT_1')}<br />
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TEXT_2')}<br />
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TEXT_3')}
                                        </>
                                    )}
                                    {isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TEXT_1') + ' '}
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TEXT_2') + ' '}
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TEXT_3')}
                                        </>
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className="how-to-read-cl-legend-list-one-content">
                            <div className="how-to-read-cl-legend-list-one-content-number">
                                <span>4</span>
                            </div>
                            <div className="how-to-read-cl-legend-list-one-content-text">
                                <span className="how-to-read-cl-legend-list-one-content-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_DIA_TITLE')}</span>
                                <br />
                                <span className="how-to-read-cl-legend-list-one-content-text-text">
                                    {!isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_DIA_TEXT_1')}<br />
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_DIA_TEXT_2')}
                                        </>
                                    )}
                                    {isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_DIA_TEXT_1') + ' '}
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_DIA_TEXT_2')}
                                        </>
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="how-to-read-cl-legend-list-two">
                        <div className="how-to-read-cl-legend-list-two-content">
                            <div className="how-to-read-cl-legend-list-two-content-number">
                                <span>5</span>
                            </div>
                            <div className="how-to-read-cl-legend-list-two-content-text">
                                <span className="how-to-read-cl-legend-list-one-content-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_CYL_TITLE')}</span>
                                <br />
                                <span className="how-to-read-cl-legend-list-one-content-text-text">
                                    {!isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_CYL_TEXT_1')}<br />
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_CYL_TEXT_2')}
                                        </>
                                    )}
                                    {isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_CYL_TEXT_1') + ' '}
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_CYL_TEXT_2')}
                                        </>
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className="how-to-read-cl-legend-list-two-content">
                            <div className="how-to-read-cl-legend-list-two-content-number">
                                <span>6</span>
                            </div>
                            <div className="how-to-read-cl-legend-list-two-content-text">
                                <span className="how-to-read-cl-legend-list-one-content-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_AXIS_TITLE')}</span>
                                <br />
                                <span className="how-to-read-cl-legend-list-one-content-text-text">
                                    {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_AXIS_TEXT')}
                                </span>
                            </div>
                        </div>
                        <div className="how-to-read-cl-legend-list-two-content">
                            <div className="how-to-read-cl-legend-list-two-content-number">
                                <span>7</span>
                            </div>
                            <div className="how-to-read-cl-legend-list-two-content-text">
                                <span className="how-to-read-cl-legend-list-one-content-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TITLE')}</span>
                                <br />
                                <span className="how-to-read-cl-legend-list-one-content-text-text">
                                    {!isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TEXT_1')}<br />
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TEXT_2')}<br />
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TEXT_3')}
                                        </>
                                    )}
                                    {isMobile && (
                                        <>
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TEXT_1') + ' '}
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TEXT_2') + ' '}
                                            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TEXT_3')}
                                        </>
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    );
};

export default HowToReadPrescriptionCL;